import ajax from '../../lib/ajax';
import util from '../../lib/util'
import {Store,Module,ActionContext} from 'vuex' 
interface SessionState{
    application:any,
    user:any,
    tenant:any
}
class SessionStore implements Module<SessionState,any>{
    namespaced=true;
    state={
        application:null,
        user:null,
        tenant:null
    }
    actions={
        async init(content:ActionContext<SessionState,any>){
            const token = util.abp.auth.getToken();
            if (!token) {
                content.state.application = null;
                content.state.user = null;
                content.state.tenant = null;
                return;
            }

            // Token'dan kullanıcı adını çöz (yedek olarak)
            let userFromToken: any = null;
            try {
                const payloadPart = token.split('.')[1];
                const json = decodeURIComponent(
                    atob(payloadPart.replace(/-/g, '+').replace(/_/g, '/'))
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                const payload = JSON.parse(json);
                const userName =
                    payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'] ||
                    payload['unique_name'] ||
                    payload['name'] ||
                    payload['nameid'] ||
                    payload['sub'];
                if (userName) {
                    userFromToken = { userName: String(userName) };
                }
            } catch (e) {
                userFromToken = null;
            }

            try {
                let rep = await ajax.get(
                    '/api/services/app/Session/GetCurrentLoginInformations'
                );
                const result = rep.data.result || {};
                content.state.application = result.application;
                content.state.user = result.user || userFromToken;
                content.state.tenant = result.tenant;
            } catch (e) {
                content.state.user = userFromToken;
            }
        }
    }
}
const session=new SessionStore();
export default session;